import { strCol, dateTimeCol, intCol } from '@integec/grid-tools'
import { utilityHeader, unitIdHeader } from 'core/HeaderColTypeProps'

export const headers = [
  utilityHeader,
  unitIdHeader,
  intCol({
    ident: 'year',
    display: 'Year',
    isKey: true,
  }),
  intCol({
    ident: 'eventNum',
    display: 'Event Number',
    isKey: true,
    width: 70,
  }),
  intCol({
    ident: 'eventIdx',
    display: 'Event Index',
    isKey: true,
    width: 70,
  }),
  strCol({
    ident: 'revCode',
    display: 'Rev Code',
  }),
  strCol({
    ident: 'eventType',
    display: 'Event Type',
  }),
  intCol({
    ident: 'ioCode',
    display: 'Dominant',
  }),
  dateTimeCol({
    ident: 'eventStart',
    display: 'Event Start Date',
    width: 150,
  }),
  strCol({
    ident: 'eStartZone',
    display: 'Event Start Zone',
  }),
  dateTimeCol({
    ident: 'eventEnd',
    display: 'Event End Date',
    width: 150,
  }),
  strCol({
    ident: 'eEndZone',
    display: 'Event End Zone',
  }),
  intCol({
    ident: 'availCap',
    display: 'Available Capacity',
  }),
  intCol({
    ident: 'causeCode',
    display: 'Cause Code',
  }),
  intCol({
    ident: 'conCode',
    display: 'Contribution Code',
  }),
  dateTimeCol({
    ident: 'workStart',
    display: 'Work Start Date',
    width: 150,
  }),
  strCol({
    ident: 'wStartZone',
    display: 'Work Start Zone',
  }),
  dateTimeCol({
    ident: 'workEnd',
    display: 'Work End Date',
    width: 150,
  }),
  strCol({
    ident: 'wEndZone',
    display: 'Work End Zone',
  }),
  intCol({
    ident: 'manHour',
    display: 'Man Hours',
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 400,
  }),
  strCol({
    ident: 'failCode',
    display: 'Fail Code',
  }),
  strCol({
    ident: 'line',
    display: 'Line',
  }),
  strCol({
    ident: 'lockReleased',
    display: 'Lock Released',
  }),
]

export const title = 'Card 97'

const readOnlyCols = ['utility', 'unit', 'year', 'eventNum', 'eventIdx']

export const isEditable = ({ header }) => !readOnlyCols.includes(header.ident)
